import {
    Routes,
    Route,
    BrowserRouter
} from 'react-router-dom'
import { default as OscHome }  from '../pages/Osc/Home'
import { default as AdminHome }  from '../pages/Admin/Home'
import { default as AdminLogin } from '../pages/Admin/Login'
import { Diagnosis as AdminDiagonsis } from '../pages/Admin/Diagnosis/Diagnosis'
import Metrics from '../pages/Osc/Metrics'
import Result from '../pages/Osc/Result'
import Login from '../pages/Osc/Login'
import { Register } from '../pages/Osc/Register'
import { DiagnosisForm } from '../pages/Admin/Diagnosis/DiagnosisForm'
import { ReplyDiagnosis } from '../pages/Osc/Diagnosis/ReplyDiagnosis'
import { ResultDiagnosis } from '../pages/Osc/Diagnosis/ResultDiagnosis'
import { List } from '../pages/Admin/Osc/List'
import { ForgotPassword } from '../pages/Osc/ForgotPassword'
import { Ebooks } from '../pages/Admin/Library/Ebooks'
import { Hints } from '../pages/Admin/Library/Hints'
import { Video } from '../pages/Admin/Library/Video'
import { Material } from '../pages/Admin/Library/Material'
import { Relatory } from '../pages/Admin/Relatory'
import { Onboarding } from '../pages/Admin/Onboarding'
import { Ebooks  as OscEbook } from '../pages/Osc/Library/Ebooks'
import { Hints  as OscHints  } from '../pages/Osc/Library/Hints'
import { Video  as OscVideo } from '../pages/Osc/Library/Video'
import { Material as OscMaterial } from '../pages/Osc/Library/Material'
import { ByCause } from '../pages/Admin/Relatory/ByCause'
import { ByRegion } from '../pages/Admin/Relatory/ByRegion'
import { Me } from '../pages/Osc/Me'
import { AdminUser } from '../pages/Admin/AdminUser'
import { Email } from '../pages/Admin/Email'
import { NewEmail } from '../pages/Admin/Email/NewEmail'
import { Traill } from '../pages/Admin/Trail'
import { TrailsForm } from '../components/Trails/TrailsForm'
import { ListDiagnosis } from '../pages/Osc/ListDiagnosis'


const Router = () => {

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/osc" >
                    <Route index element={ <OscHome /> } />
                    <Route path="metricas" element={ <Metrics /> } />
                    <Route path="jornada" element={ <ListDiagnosis /> } />
                    <Route path="meu-perfil" element={ <Me/> } />
                    <Route path="resultado" element={ <Result /> } />
                    <Route path="login" element={ <Login /> } />
                    <Route path="registro" element={ <Register /> } />
                    <Route path="responder/:id" element={<ReplyDiagnosis/>}/>
                    <Route path="resultado/:id" element={<ResultDiagnosis/>}/>
                    <Route path="esqueci-senha" element={<ForgotPassword />} />
                    <Route path="biblioteca">
                        <Route index element={<OscEbook/>}/>
                        <Route path="dicas" element={<OscHints/>}/>
                        <Route path="videos" element={<OscVideo/>}/>
                        <Route path="material-complementar" element={<OscMaterial/>}/>
                    </Route>
                </Route>
                <Route path="/admin" >
                    <Route index element={ <AdminHome /> } />
                    <Route path="login" element={ <AdminLogin /> } />
                    <Route path="testes">
                        <Route index element={<AdminDiagonsis />} />
                        <Route path="novo" element={<DiagnosisForm/>}/>
                        <Route path=":id" element={<DiagnosisForm/>}/>
                    </Route>
                    <Route path="osc" element={<List/>}/>
                    <Route path="biblioteca">
                        <Route index element={<Ebooks/>}/>
                        <Route path="dicas" element={<Hints/>}/>
                        <Route path="videos" element={<Video/>}/>
                        <Route path="material-complementar" element={<Material/>}/>
                        <Route path="novo">
                            <Route index element={<Ebooks form />}/>
                            <Route path="dicas" element={<Hints form />}/>
                            <Route path="videos" element={<Video form />}/>
                            <Route path="material-complementar" element={<Material form/>}/>
                        </Route>
                    </Route>
                    <Route path="emails">
                            <Route index  element={<Email/>}/>
                            <Route path='novo-email'element={<NewEmail/>}/>
                    </Route>
                    <Route path="relatorios">
                            <Route index element={<Relatory/>}/>
                            <Route path='por-causa' element={<ByCause/>} />
                            <Route path='por-regiao' element={<ByRegion/>} />
                    </Route>
                    <Route path="slides" element={<Onboarding/>}/>
                    <Route path="trilha">
                        <Route index element={<Traill />}/>
                        <Route path='nova' element={<TrailsForm />} />
                        <Route path=':id' element={<TrailsForm />}/>
                    </Route>
                    <Route path="admin" element={<AdminUser/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default Router
